import Vue from 'vue';
import moment from 'moment';

Vue.mixin({
  methods: {
    formatDate(date) {
      return date ? moment(date).format('LLL') : '-';
    },
    convertDate(date) {
      return date ? moment(date).format('LLL') : '-';
    }
  }
});
